<template>
  <svg xmlns="http://www.w3.org/2000/svg" 
    :width="width" 
    :height="height" 
    viewBox="0 0 24 24" 
    :aria-labelledby="iconName" 
    role="presentation"
  >
    <title :id="iconName" lang="en">{{iconName && showIconName ? iconName + 'icon': null }}</title>
    <g :fill="iconColor" :stroke="iconStroke" :stroke-width="iconStrokeWidth">
      <slot />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
    },
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    },
    iconColor: {
      type: String,
      default: 'none'
    },
    iconStroke:{
        type: String,
        default: 'currentColor'
    },
    iconStrokeWidth:{
        type: String,
        default: '2'
    },
    showIconName:{
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px;
  
}
title:hover{
  display: none;
}
</style>